import { track } from "jiffy-analytics";
import { isTouchDevice, isPhone } from "common/utils/browser";
import { on as onEvent } from "common/utils/ui/event";
import { initStayOpenOnHover } from "components/compositions/softness_score/component";
import { remoteImageStaticUrl } from "common/utils/remote-image";
import "./component.scss";

class Tooltip {
  config = {};

  constructor(config) {
    this.config = config;
  }

  get $tooltips() {
    return document.querySelectorAll(this.config.selector);
  }

  get $$tooltips() {
    return $(this.config.selector);
  }

  initTooltip() {
    const { eventName } = this.config;

    this.$$tooltips
      .tooltip({
        animation: false,
        container: "body",
        delay: {
          show: isTouchDevice() ? 0 : 500,
          hide: 100
        },
        html: true,
        title: this.config.content,
        template: this.config.template,
        trigger: isTouchDevice() ? "click" : "hover",
        placement: isPhone() ? "bottom" : "top"
      })
      .on("show.bs.tooltip", () => {
        track(eventName, {
          source: "satisfaction_guarantee"
        });
      });
  }

  initTooltipClose() {
    const callback = e => {
      e.preventDefault();
      this.$$tooltips.tooltip("hide");
    };

    onEvent("click", this.config.closeSelector, callback, true);
  }

  stopBubbling() {
    this.$tooltips.forEach($badge => {
      $badge.addEventListener("click", e => {
        e.preventDefault();
        e.stopPropagation();
      });
    });
  }

  init() {
    initStayOpenOnHover();
    this.initTooltip();
    this.initTooltipClose();
    this.stopBubbling();
  }
}

const tooltipContent = `
  <div id="js-softness-score-tooltip-content" class="satisfaction-guaranteed__tooltip">
    <div class="satisfaction-guaranteed__tooltip-head">
      <div class="satisfaction-guaranteed__tooltip-head-image">
        <img src="${remoteImageStaticUrl("gen/guarantee-shield.png", { ixlib: "rb-0.3.5", auto: "format" })}" class="satisfaction-guaranteed__tooltip-head-icon" />
      </div>
      <h5 class="satisfaction-guaranteed__tooltip-head-title">
        Satisfaction Guaranteed
      </h5>
      <a
        class="softness-score__tooltip-close satisfaction-guaranteed__tooltip-close js-satisfaction-guaranteed-tooltip-close"
        role="button"
        tabindex="-1"
      ></a>
    </div>
    <div class="satisfaction-guaranteed__tooltip-content">
      <ul class="satisfaction-guaranteed__tooltip-list">
        <li class="satisfaction-guaranteed__tooltip-list-item">
          <img src="${remoteImageStaticUrl("gen/check-circle.png", { ixlib: "rb-0.3.5", auto: "format" })}" class="satisfaction-guaranteed__tooltip-list-icon" />
          Premium print quality
        </li>
        <li class="satisfaction-guaranteed__tooltip-list-item">
          <img src="${remoteImageStaticUrl("gen/check-circle.png", { ixlib: "rb-0.3.5", auto: "format" })}" class="satisfaction-guaranteed__tooltip-list-icon" />
          Advanced imaging technology
        </li>
        <li class="satisfaction-guaranteed__tooltip-list-item">
          <img src="${remoteImageStaticUrl("gen/check-circle.png", { ixlib: "rb-0.3.5", auto: "format" })}" class="satisfaction-guaranteed__tooltip-list-icon" />
          Built to last
        </li>
        <li class="satisfaction-guaranteed__tooltip-list-item">
          <img src="${remoteImageStaticUrl("gen/check-circle.png", { ixlib: "rb-0.3.5", auto: "format" })}" class="satisfaction-guaranteed__tooltip-list-icon" />
          We quality check every product
        </li>
      </ul>
      <div class="satisfaction-guaranteed__tooltip-content-hint">Love it or send it back!</div>
    </div>
  </div>`;

const tooltipTemplate = `
  <div class="tooltip softness-score__tooltip" role="tooltip">
    <div class="softness-score__tooltip-arrow tooltip-arrow satisfaction-guaranteed__tooltip-arrow"></div>
    <div class="softness-score__tooltip-inner tooltip-inner"></div>
  </div>`;

const init = (options = {}) => {
  new Tooltip({
    selector: ".js-satisfaction-guaranteed-tooltip",
    closeSelector: ".js-satisfaction-guaranteed-tooltip-close",
    content: tooltipContent,
    template: tooltipTemplate,
    eventName: options.eventName
  }).init();
};

export default init;
